import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';

export const ModalModifier = ({ items, dishCategory, category, localModifiers, setLocalModifiers }) => {
    const isCategoryRemove = dishCategory?.modifier_items.length === 1;

    const handleModifier = (e, modifier) => {
        const checked = e.target.checked;

        setLocalModifiers((prev) => {

            if (!dishCategory && checked) {
                return [...prev, { ...category, modifier_items: [modifier] }];
            }

            if (dishCategory && !checked && isCategoryRemove) {
                return prev.filter((item) => item.id !== category.id);
            }

            return prev.map((cat) => {
                if (cat.id === category.id) {
                    const find = cat.modifier_items.find((item) => item.id === modifier.id);

                    if (find && !checked) {
                        return { ...cat, modifier_items: cat.modifier_items.filter((item) => item.id !== modifier.id) };
                    }

                    if (!find && checked) {
                        return { ...cat, modifier_items: [...cat.modifier_items, modifier] };
                    }
                    return cat;
                }
                return cat;
            });
        });
    };

    if (!items) return null;

    return (
        <div>
            {items.map((item) => {
                const isDefaultChecked = dishCategory?.modifier_items.some((modifier) => modifier.id === item.id);
                return (
                    <div key={item.id} className="sm:rounded-lg my-1 mx-auto pl-6 py-1.5 w-full text-sm font-medium">
                        <div className="px-2 flex items-center">
                            <input type="checkbox" name={item.name} id={item.id} defaultChecked={!!isDefaultChecked} checked={!!isDefaultChecked} onChange={(e) => handleModifier(e, item)} height={20} width={44} />
                            <label className="text-sm font-semibold ml-5 cursor-pointer" htmlFor={item.id}>
                                {item.name}
                            </label>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};
